@if (!loading() && creditTransfers.length > 0) {
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>{{ "CREDITS.TRANSFERS.TITLE" | translate }}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="transfer-list">
      @for (item of pagedCreditTransfers; track item.id) {
        <mat-card appearance="outlined">
          <mat-card-content class="transfer-item">
            <div class="transfer-created-at">
              {{ item.created_at | date: "yyyy.MM.dd HH:mm" }}
            </div>
            <div class="transfer-state">
              <span [class]="item.state">{{ "CREDITS.TRANSFERS.STATE." + item.state | translate }}</span>
              @if (item.state === "pending") {
                <button
                  payee-mini-icon-button
                  color="white"
                  (click)="cancelCreditTransfer(item)"
                >
                  <payee-icon name="trash-red"></payee-icon>
                </button>
              }
            </div>
            <div class="transfer-amount">
              {{ item.amount | currency: item.currency_iso : "symbol-narrow" : "1.0" : "hu" }}
            </div>
          </mat-card-content>
        </mat-card>
      }
    </mat-card-content>
    <mat-card-footer>
      @if (creditTransfers.length > 5) {
        <mat-paginator
          [length]="creditTransfers.length"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          [pageSizeOptions]="[1, 5, 10, 25]"
          (page)="pageChange($event)"
        ></mat-paginator>
      }
    </mat-card-footer>
  </mat-card>
}
